<template lang="pug">
.login-modal
  v-dialog(
    v-model="dialog"
    max-width="400"
    persistent)
    v-card
      v-card-title.headline 會員登入
      v-card-text
        login-form(
          ref="form"
          v-if="dialog"
          @cancel="dialog = false"
          @submit-succeed="dialog = false")
</template>
<script>
import LoginForm from "@/components/forms/LoginForm.vue";

export default {
  name: "LoginModal",
  components: {
    LoginForm
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
